import {fromJS, Map} from 'immutable';
import errorActions from '../actions/error.actions';
import dieselReducer from 'epic-diesel-common/src/decorators/DieselReducer';
import {ServerError} from '../../shared/types';

export interface ErrorState extends ServerError {
    show: boolean;
}

export const DEFAULT_STATE = fromJS({
    show: false,
    errorCode: '',
    errorMessage: '',
    messageVars: [],
    numericErrorCode: 0
});

export const errorReducer = (state: Map<keyof ErrorState, any> = DEFAULT_STATE, action) => {
    const newState = state;

    switch (action.type) {
        case errorActions.TYPES.SHOW_ERROR_MESSAGE:
            return newState.merge({
                show: true,
                ...action.payload
            });

        case errorActions.TYPES.HIDE_ERROR_MESSAGE:
            return DEFAULT_STATE;

        default:
            return newState;
    }
};

export default dieselReducer('error', errorReducer);
